const flowProducts = [
  {
    id: 1,
    name: "Electromagnetic Flow Meter",
    description: "Accurate flow measurement for conductive liquids.",
    image: "/assets/sensors/FM.png",
    pdf: "/assets/pdf/sample.pdf",    // update path to actual datasheet
    price: "₹5,500"
  },
  {
    id: 2,
    name: "Ultrasonic Flow Meter",
    description: "Non-invasive flow measurement using ultrasonic waves.",
    image: "/assets/sensors/FM.png",
    pdf: "/assets/pdf/sample.pdf",
    price: "₹7,200"
  },
  {
    id: 3,
    name: "Turbine Flow Meter",
    description: "Ideal for clean, low-viscosity liquids and gases.",
    image: "/assets/sensors/FM.png",
    pdf: "/assets/pdf/sample.pdf",
    price: "₹6,000"
  }
];

export default flowProducts;
